import AddDOIModal from "../addDOIModal";
import { useState } from "react";
import { HiOutlineExternalLink }  from "react-icons/hi";
import { API } from "../../../../Common/lib/api";

/**
 * Returns the Project DOI row component.
 *
 * @param {*} param0
 * @returns The Project DOI row component.
 */
const ProjectRow = ({
    project,
    formatUNIX,
    updateProjectDOI,
    rejectDOIRequest,
    users,
}) => {
    const [openDOIModal, setOpenDOIModal] = useState(false);

    function getUsersName() {
      if (!Array.isArray(users) || users.length === 0 || !project.userID) {
        return "";
      }

      const user = users.find((user) => user.Username === project.userID);
      if (!user || !Array.isArray(user.Attributes)) {
        return "";
      }

      const firstName = user.Attributes.find((attribute) => attribute.Name === "given_name")?.Value || "";
      const lastName = user.Attributes.find((attribute) => attribute.Name === "family_name")?.Value || "";

      const fullName = `${firstName} ${lastName}`.trim();
      return fullName || "";
    }

    return (
        <>
            <tr className="py-12" key={project.id}>
                <td className="max-w-0 py-4 pl-6 pr-3 text-sm sm:text-base font-medium text-black sm:w-auto sm:max-w-none sm:pl-6 whitespace-normal break-all">
                  <div className='flex hover:underline cursor-pointer'
                    onClick={async () => {
                      let projectId = project.projectID;
                      if (projectId && projectId.startsWith('project-')) {
                        try {
                          const projectQuery = await API.projects.get(projectId, projectId);
                          const projectObj = projectQuery.data.getProject;
                          projectId = projectObj?.id || projectId.substring(8);
                        } catch (e) {
                          projectId = projectId.substring(8);
                        }
                      } else {
                        projectId = projectId?.substring(8) || projectId;
                      }
                      window.open("/metadata-display/" + projectId);
                    }}
                  >
                    <a className="hover:underline whitespace-normal break-all">
                      {project.projectTitle}
                    </a>
                    <div className='pl-1.5'>
                      <HiOutlineExternalLink/>
                    </div>
                  </div>



                    <dl className="font-normal lg:hidden">
                        <dt className="sr-only sm:hidden">Created By</dt>
                        <dd className="mt-1 truncate text-gray-500 sm:hidden">{getUsersName()}</dd>
                    </dl>
                </td>

                {window.location.href.includes("doi-requests") &&
                  <>
                    <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell whitespace-normal break-all">
                      <span>{project.doi || project.doiRequested || "N/A"}</span>
                    </td>

                    <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell whitespace-normal break-all">
                      {getUsersName()}
                    </td>
                  </>
                }


                <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
                    {formatUNIX(project.createdAt)}
                </td>

                <td className="py-4 pl-3 pr-6 space-y-3 text-right text-sm sm:text-base font-medium sm:space-y-0 sm:space-x-3 sm:pr-6 max-w-1/4">
                  <div className="sm:flex sm:space-x-2 sm:space-y-0 space-y-2">
                    <button
                      type="button"
                      className="rounded-md w-full bg-blue-600 py-1 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      data-cy="add-doi"
                      onClick={() => setOpenDOIModal(true)}
                    >
                      Add DOI
                    </button>
                    <button
                      type="button"
                      className="rounded-md w-full py-1 px-4 text-sm font-medium shadow-sm text-gray-700 bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      data-cy="reject"
                      onClick={() => rejectDOIRequest(project)}
                    >
                      Reject
                    </button>
                  </div>
                </td>
            </tr>
            <AddDOIModal setOpenDOIModal={setOpenDOIModal} openDOIModal={openDOIModal} updateProjectDOI={updateProjectDOI} project={project}/>
        </>
    );
};

export default ProjectRow;